
const Renderer = require("prosemirror-to-html-js").Renderer;
const renderer = new Renderer();

export function json2Html (jsonContent) {
  return renderer.render(jsonContent)
}
